import {gql} from '@apollo/client';
import {pwaClient} from './graphql_clients';
import {EmailLoginMutation, FacebookLoginQuery, GoogleLoginQuery, LoginQuery} from '../gql/pwa/graphql';
import {pwaRequestHeaders} from '../support/network.ts';

const SEND_MAIL = gql`
    mutation emailLogin($email: String!) {
        customerRestore(email: $email)
    }
`;

const EXCHANGE_EMAIL_WITH_CODE = gql`
    query login($email: String!, $code: String!) {
        login(email: $email, code: $code) {
            token
            onboarding_completed
            show_onboarding
            __typename
        }
    }
`;

const FACEBOOK_LOGIN = gql`
    query facebookLogin($token: String!) {
        facebookLogin(token: $token) {
            token
            onboarding_completed
            show_onboarding
            __typename
        }
    }
`;

const GOOGLE_LOGIN = gql`
    query googleLogin($token: String!) {
        googleLogin(token: $token) {
            token
            onboarding_completed
            show_onboarding
            __typename
        }
    }
`;

export class Auth {
    static async requestEmailLink(email: string) {
        const result = await pwaClient.mutate<EmailLoginMutation>({
            mutation: SEND_MAIL,
            variables: {
                email: email,
            },
            context: {
                headers: pwaRequestHeaders,
            },
        });
        return result;
    }

    static async exchangeEmailWithCode(email: string, code: string) {
        const result = await pwaClient.query<LoginQuery>({
            query: EXCHANGE_EMAIL_WITH_CODE,
            variables: {
                email: email,
                code: code,
            },
            context: {
                headers: pwaRequestHeaders,
            },
        });

        return result;
    }

    static async facebookLogin(facebookToken: string) {
        const result = await pwaClient.query<FacebookLoginQuery>({
            query: FACEBOOK_LOGIN,
            variables: {
                token: facebookToken,
            },
            context: {
                headers: pwaRequestHeaders,
            },
        });
        return result;
    }

    static async googleLogin(googleToken: string) {
        const result = await pwaClient.query<GoogleLoginQuery>({
            query: GOOGLE_LOGIN,
            variables: {
                token: googleToken,
            },
            context: {
                headers: pwaRequestHeaders,
            },
        });
        return result;
    }
}
